<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'customize-field-formula.configuration-group'">Configuración de la fórmula</span>
  </div>
  <!-- Contenedor -->
  <div class="formula-setting-modal__body-container">
    <div class="formula-setting-modal__values-container">
      <div class="formula-setting-modal__search-list-container">
        <div class="common-dropdown-list__overlay-header-search-container">
          <div class="common-search__container-tonal">
            <div class="common-search__container-input-text">
              <input type="search"
                class="common-search__input-text"
                [(ngModel)]="formulaSettingModal.searchFields"
                [placeholder]="'customize-field-formula.search-field-to-concept' | afTranslate">
            </div>
            <div class="common-search__block-button-search">
              @if(formulaSettingModal.searchFields){
                <button class="common-button__icon-xs-noborder"
                  (click)="resetSearch()">
                  <i class="lf-icon-close-thick common-icon__sm"></i>
                </button>
              }
              <div class="h-[22px]"
                  ngClass="{{formulaSettingModal.searchFields?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}"></div>
              <i class="lf-icon-search common-icon__md"
                  ngClass="{{!formulaSettingModal.searchFields?'common-search__icon-search-disabled':'common-search__icon-search-enabled'}}"></i>
            </div>
          </div>
        </div>
        <div class="formula-setting-modal__list-items-container">
          @for (fieldContainer of formulaSettingModal.fieldContainers; track $index) {
            <div class="common-dropdown-list__cascade-item">
              <button class="common-button__icon-sm-noborder"
                (click)="fieldContainer.show = !fieldContainer.show">
                <i class="common-icon__md"
                  ngClass="{{fieldContainer.show?'lf-icon-angle-up':'lf-icon-angle-down'}}"></i>
              </button>
              <div class="common-dropdown-list__cascade-item-text-container">
                <span-tooltip class="common-dropdown-list__si-text-container"
                  [text]="fieldContainer.name"></span-tooltip>
              </div>
            </div>
            @if (fieldContainer.show) {
              @for (field of fieldContainer.fields | byWord: formulaSettingModal.searchFields:['label']; track $index) {
                @if (field.show) {
                  <div class="common-dropdown-list__cascade-item"
                    [ngStyle]="{'padding-left': '16px'}">
                    <div class="common-dropdown-list__cascade-label-container">
                      <div class="common-button__block-button-md-checkbox">
                        <button class="common-button__icon-md-checkbox"
                          [ngClass]="{'common-button__icon-md-checkbox--selected': field.selected}"
                          (click)="selectFieldToOperation(field)"
                          [disabled]="formulaSettingModal.valueNumber">
                          <i class="common-icon__md"
                            ngClass="{{field.selected?'lf-icon-radio-button-active':'lf-icon-step-first'}}"></i>
                        </button>
                      </div>
                      <div class="common-dropdown-list__cascade-item-text-container">
                        <span-tooltip class="common-dropdown-list__si-text-container"
                          [text]="field.label"></span-tooltip>
                      </div>
                    </div>
                  </div>
                }
              }
              @for (subContainer of fieldContainer.subContainers; track $index) {
                <div class="common-dropdown-list__cascade-item"
                  [ngStyle]="{'padding-left': '24px'}">
                  <button class="common-button__icon-sm-noborder"
                    (click)="subContainer.show = !subContainer.show">
                    <i class="common-icon__md"
                      ngClass="{{subContainer.show?'lf-icon-angle-up':'lf-icon-angle-down'}}"></i>
                  </button>
                  <div class="common-dropdown-list__cascade-item-text-container">
                    <span-tooltip class="common-dropdown-list__si-text-container"
                      [text]="subContainer.name"></span-tooltip>
                  </div>
                </div>
                @if (subContainer.show) {
                  @for (fieldSubcontainer of subContainer.fields | byWord:formulaSettingModal.searchFields:['label']; track $index) {
                    @if (fieldSubcontainer.show) {
                      <div class="common-dropdown-list__cascade-item"
                        [ngStyle]="{'padding-left': '32px'}">
                        <div class="common-dropdown-list__cascade-label-container">
                          <div class="common-button__block-button-md-checkbox">
                            <button class="common-button__icon-md-checkbox"
                              [ngClass]="{'common-button__icon-md-checkbox--selected': fieldSubcontainer.selected}"
                              (click)="selectFieldToOperation(fieldSubcontainer)"
                              [disabled]="formulaSettingModal.valueNumber">
                              <i class="common-icon__md"
                                ngClass="{{fieldSubcontainer.selected?'lf-icon-radio-button-active':'lf-icon-step-first'}}"></i>
                            </button>
                          </div>
                          <div class="common-dropdown-list__cascade-item-text-container">
                            <span-tooltip class="common-dropdown-list__si-text-container"
                              [text]="fieldSubcontainer.label"></span-tooltip>
                          </div>
                        </div>
                      </div>
                    }
                  }
                }
              }
            }
          }
        </div>
      </div>
      <field-type-number class="flex w-full"
        [field]="formulaSettingModal.numberValueField"
        [preSelectItem]="formulaSettingModal.valueNumber"
        [decimals]="10"
        (itemSelected)="selectValueToOperation($event)">
      </field-type-number>
      <button class="common-button__text-little-noborder"
        [disabled]="!formulaSettingModal.selectedValue && !formulaSettingModal.valueNumber"
        (click)="addOperationValue()">
        <span class="common-button__text-little-title"
          [afTranslate]="'customize-field-formula.add-to-operation'">_Añadir a la operación</span>
        <i class="lf-icon-arrow-right-box common-icon__sm"></i>
      </button>
    </div>
    <div class="common-toolbox__container-vertical">
      @for (operator of formulaSettingModal.operators; track $index) {
        <button class="common-button__icon-md-noborder"
          (click)="addOperator(operator)">
          <i [class]="operator.icon + ' common-icon__md'"></i>
        </button>
        @if (!$last) {
          <div class="common-divider__horizontal-grey-300 w-[30px]"></div>
        }
      }
    </div>
    <div class="formula-setting-modal__operation-container">
      <div class="formula-setting-modal__buttons-menu-container">
        <div class="common-tab__secondary-list-block">
          <button (click)="formulaSettingModal.showFormulaSimple = !formulaSettingModal.showFormulaSimple"
            class="common-tab__secondary"
            [ngClass]="{'common-tab__secondary--selected': !formulaSettingModal.showFormulaSimple}">
            <p class="common-tab__secondary-button-text" [afTranslate]="'customize-field-formula.view-format'">Vista formateada</p>
          </button>
          <button (click)="formulaSettingModal.showFormulaSimple = !formulaSettingModal.showFormulaSimple"
            class="common-tab__secondary"
            [ngClass]="{'common-tab__secondary--selected': formulaSettingModal.showFormulaSimple}">
            <p class="common-tab__secondary-button-text" [afTranslate]="'customize-field-formula.simple-text'">_Texto simple</p>
          </button>
        </div>
        <div class="common-section-title__dp-buttons-container">
          <button class="common-button__icon-lg-border"
            (click)="deleteLastItem()">
            <i class="lf-icon-arrow-back common-icon__md"></i>
          </button>
          <button class="common-button__icon-lg-border"
            (click)="resetFormula()">
            <i class="lf-icon-eraser common-icon__md"></i>
          </button>
        </div>
      </div>
      <div class="formula-setting-modal__operation-body-container"
        [ngClass]="{'formula-setting-modal__operation-body-container--with-values': formulaSettingModal.formulaItems?.length}">
        @for (item of formulaSettingModal.formulaItems; track $index) {
          @if(formulaSettingModal.showFormulaSimple){
            <span class="formula-setting-modal__operation-formu-simple"
              [ngClass]="{'formula-setting-modal__operation-formu-simple--error': item.deleted}">{{item.text}}</span>
          }@else {
            @if(item.text === '(' || item.text === ')'){
              <div class="formula-setting-modal__container-icon-bracket"
                [ngStyle]="{'padding-left': (16*(item.level-1)) + 'px'}">
                <i [class]="item.icon + ' common-icon__md formula-setting-modal__icon-formu-lvl-' + item.level"></i>
              </div>
            }@else if(item.type === 'operator'){
              <i [class]="item.icon + ' common-icon__md formula-setting-modal__icon-formu-lvl-' + item.level"
                [ngStyle]="{'margin-left': (item.firstChild?16*(item.level):0) + 'px'}"></i>
            }@else {
              <span-tooltip [ngStyle]="{'margin-left': (item.firstChild?16*(item.level):0) + 'px'}"
                [class]="'formula-setting-modal__formu-number formula-setting-modal__formu-number--lvl-' + item.level"
                [ngClass]="{'formula-setting-modal__formu-number--error': item.deleted}"
                [text]="item.text"></span-tooltip>
            }
          }
        }@empty {
          <div class="formula-setting-modal__operation-empty-container">
            <div class="formula-setting-modal__operation-empty-title"
              [afTranslate]="'formula-setting-modal.operations-area'">_Zona de operaciones</div>
            <div class="formula-setting-modal__operation-empty-info"
              [afTranslate]="'formula-setting-modal.operations-area-info'">_Construye la fórmula relacionando variables o valores fijos mediante operadores matemáticos</div>
          </div>
        }
      </div>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer-container-end">
    @if (formulaSettingModal.errorValueFormula) {
      <div class="common-status-message__g-container-alert">
        <i class="lf-icon-close-round-full common-status-message__icon-md"></i>
        <div class="common-status-message__g-content">
          <div class="common-status-message__g-icon-text-content">
            <div class="common-status-message__g-title-subtitle">
              <span class="common-status-message__g-subtitle"
                [afTranslate]="configurationField.formulaFieldsDeleted?'customize-field-formula.formula-error-field-deleted':'customize-field-formula.error-add-value'"></span>
            </div>
            <button class="common-button__icon-xs-noborder"
              (click)="formulaSettingModal.errorValueFormula = false">
              <i class="lf-icon-close-thick common-icon__sm"></i>
            </button>
          </div>
        </div>
      </div>
    }
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text"
        (click)="handleAccept()">
        <span class="common-button__text-title"
          [afTranslate]="'common.save'">_Guardar</span>
      </button>
    </div>
  </div>
</div>
